import styled from 'styled-components'

export const PlayModalContainer = styled.div`
  height: 100vh;
  overflow: hidden;
`
